import { render, staticRenderFns } from "./VendorNew.vue?vue&type=template&id=c81283d8&scoped=true&"
import script from "./VendorNew.vue?vue&type=script&lang=js&"
export * from "./VendorNew.vue?vue&type=script&lang=js&"
import style0 from "./_layout.css?vue&type=style&index=0&id=c81283d8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c81283d8",
  null
  
)

export default component.exports